import React, { Component ,useEffect, useState} from "react";
import {Link, useNavigate } from "react-router-dom";
import { Layout, Typography, Button, Table, Tag, Badge, Spin, Empty, Drawer, Space, Upload, message, Progress, Popover, Divider } from "antd";
import { PlusOutlined, FilePdfTwoTone, UploadOutlined, SyncOutlined, CheckCircleFilled } from "@ant-design/icons"
import '../styles.css'
import api from "../api";
import { utilities } from "../../../utilities/utlities";
import { useQuery } from 'react-query'
const AdminRFQ =(props)=> {
    const [loading,setLoading] = useState(false)
    const [data,setData] = useState([])
    const [authorized, setAuthorized] = useState(true)
    const [showDrawer, setShowDrawer] = useState(false);
    const [fileList, setFileList] = useState([])
    const [generating, setGenerating] = useState(false)
    const [rfq, setRfq] = useState(null)
    let [percent, setPercent] = useState(0)
    let [missingProducts, setMissingProducts] = useState([])
    const  navigate = useNavigate()
    const [user, setUser] = useState(null)
    const [selectedRFQ, setSelectedRFQ] = useState('')
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id'
        },
        {
            title: 'Title',
            dataIndex: 'title',
            sorter: (a, b) => a.title.length - b.title.length,
            render: (item,obj) => {
                return(
                    <Link style={{color: 'rgba(0,0,0,0.85'}} to={`/rfq/${obj._id}`} className="title">
                        {item}
                    </Link>
                )
            }
        },
        {
            title: 'Status',
            dataIndex: 'statusStr',
            render: item => {
                return(
                    <div>
                        {item == 'Closed' || item == 'Active' ?
                        <Tag color={item === 'Closed' ? 'default' : 'green'}>
                            <Badge status={item === 'Closed' ? 'default' : 'green'}/>
                            {item}
                        </Tag> :
                        <>
                            <Badge color={item === 'Draft' ? 'blue' : 'orange'} text={item}/>
                        </>
                        }   
                    </div>
                   
                )
            }
        },
        {
            title: 'File',
            dataIndex: 'document',
            render: item =>{
                return(
                    <a href={item} target='_blank'>{item}</a>
                )
            }
        },
        {
            title: 'Close Date',
            dataIndex: 'closingDate',
            sorter: (a, b) => new Date(a.closingDate) - new Date(b.closingDate)
        },
        {
            title: 'Deadline',
            dataIndex: 'deadLine',
            render: item => {
                return item ? (
                    <Tag color='red'>
                        {item}
                    </Tag>
                ) : (
                    <span>---</span>
                )
            }
        },
        {
            title: 'Actions',
            render: (item,obj) => {
                return(
                    <Popover content={popoverContent} trigger="click" placement="bottom">
                        <Text onClick={()=>setSelectedRFQ(obj._id)} style={{fontSize: 30,color: '#1890ff',cursor: 'pointer'}}>...</Text>
                    </Popover>
                )
            }
        }
    ];
    useEffect(()=>{
        let user = utilities.loggedUser()
        setUser(user)
        if(user){
            setLoading(true)
            api.getRfq((error,rfqs)=>{
                setLoading(false)
                setRFQsData(error,rfqs)
            },user.jwtToken)
        }
    },[])
    const setRFQsData = (error,rfqs) =>{
        if(error){
            message.error('Something went wrong',2)
        }else{
            let currentDate = new Date()
            for(var i=0;i<rfqs.length;i++){
                let obj = rfqs[i]
                obj.key = i.toString()
                let date = new Date(obj.closingDate)
                if(date < currentDate){
                    obj.statusStr = 'Closed'
                    obj.status = 'closed'
                }else{
                    let remaningTime = date - currentDate
                    let deadLine = utilities.getDaysHoursFromMiliseconds(remaningTime)
                    let deadlineStr = ""
                    if(deadLine.days > 0){
                        deadlineStr += (deadLine.days+'d') + " " + (deadLine.hours+'h') + " " +  (deadLine.minutes+'m')+ " " +(deadLine.sec+'s')
                    }else{
                        if(deadLine.hours > 0){
                            deadlineStr += deadLine.hours+'h' + " " +  (deadLine.minutes+'m')+ " " +(deadLine.sec+'s')
                        }else{
                            deadlineStr += (deadLine.minutes+'m') + " " +(deadLine.sec+'s')
                        }
                    }
                    obj.deadLine = deadlineStr
                }
                if(obj.status == 'published'){
                    obj.statusStr = 'Active'
                }else if(obj.status == 'draft' || !obj.status){
                    obj.statusStr = 'Draft'
                }else if(obj.status == 'cancelled'){
                    obj.statusStr = 'Cancelled'
                }
            }
            setData(rfqs)
        }
    }
    const onChangePage = (page) => {
    }
    const onClickCreateRFQ = () =>{
        setShowDrawer(true)
    }
    const onCloseDrawer = () => {
        setMissingProducts([])
        setFileList([])
        setPercent(0)
        setRfq(null)
        setShowDrawer(false)
    }
    const onClickGenerateRFQ = () => {
        if(generating){
            return
        }
        setGenerating(true)
        api.generateRFQ(fileList[0],user.jwtToken,user.type === 'admin',onUploadProgress,(error,rfqData)=>{
            if(data){
                setGenerating(false)
                setRfq(rfqData)
                setRFQsData(null,[...data,rfqData])
                let missingProducts =[]
                for(var i=0;i<rfqData.medicinesRequired.length;i++){
                    if(!rfqData.medicinesRequired[i].available){
                        missingProducts.push(rfqData.medicinesRequired[i].name + " " + rfqData.medicinesRequired[i].strength)
                    }
                }
                if(missingProducts.length > 0){
                    setMissingProducts(missingProducts)
                }
                message.success('RFQ generated',3)
                setLoading(true)
                api.getRfq((error,rfqs)=>{
                    setLoading(false)
                    setRFQsData(error,rfqs)
                },user.jwtToken)
            }else{
                message.error("Please ! Try again",3);
            }
        })
    }
    const onUploadProgress = (event) => {
        let percent = ((event.loaded / event.total) * 100).toFixed(2)
        setPercent(percent)
    }
    const popoverContent = (
        <Space direction='vertical'>
            <Link style={{color: 'rgba(0,0,0,0.85',marginBottom: 10}} to={`/rfq/${selectedRFQ}`}>
                View
            </Link>
            <Link style={{color: 'rgba(0,0,0,0.85',marginBottom: 10}} to={`/manage-rfi/${selectedRFQ}`}>
                Manage RFI
            </Link>
        </Space>
    );
    const { Content } = Layout;
    const { Text } = Typography
    return(
        <Layout className="layout">
            <Content style={{ padding: "0 12px" }}>
                <div style={{justifyContent: 'flex-start'}} className = "site-layout-content">
                    {loading ? 
                        <Spin size='large' tip='loading'/> :
                        data.length > 0 ?<>
                        <div className="header">
                            <Text>Manage RFQ</Text>
                            <Button onClick={onClickCreateRFQ} type="primary">Create RFQ</Button>
                        </div>
                        <Table className="rfiTable" style={{width: '100%'}} columns={columns} dataSource={data} pagination = {{onChange: onChangePage}} />
                    </> :
                    <> 
                    <Empty/>
                    <Button onClick={onClickCreateRFQ} icon={<PlusOutlined />} type='primary'>Create RFQ</Button>
                    </>}
                </div>
            </Content>
            <Drawer size='large' title="Create RFQ" placement='right' visible={showDrawer} onClose={onCloseDrawer}>
                <div className='drawer-content'>
                    <Space style={{alignItems: 'center',display: 'flex'}} direction='vertical' size={20}>
                        {rfq == null ? <>
                        <FilePdfTwoTone style={{color: 'blue', fontSize: 100}} />
                        <Upload
                            accept="pdf"
                            beforeUpload={(file) => {
                                const isPDF = file.type === 'application/pdf';
                                if (!isPDF) {
                                    message.error(`${file.name} is not a pdf file`,3);
                                }else{
                                    setFileList([...fileList,file])
                                }
                                return false
                            }}
                            onRemove={(file) => {
                                const index = fileList.indexOf(file);
                                const newFileList = fileList.slice();
                                newFileList.splice(index, 1);
                                setFileList(newFileList)
                            }}>
                            {fileList.length == 0 ? <Button style={{width: '50vh'}} icon={<UploadOutlined />} type='dashed' size='large'>Select RFQ Document</Button> : null}
                        </Upload>
                        {percent > 0 ?
                        <Progress 
                            style={{width: '50vh',marginLeft: 25}}
                            strokeColor={{
                                '0%': '#108ee9',
                                '100%': '#87d068',
                              }}
                        percent={percent}/> : null}
                        {fileList.length > 0 ? <Button icon={<SyncOutlined spin={generating} />} onClick={onClickGenerateRFQ} type='primary'>Generate RFQ</Button> : null}
                        <Text type='secondary'> {fileList.length == 0 ? 'Supported format: PDF' : 'How it works ?'}</Text>
                        </> : 
                        <>
                            <CheckCircleFilled style={{color: 'green',fontSize: 100}}/>
                            <Text style={{fontSize: 20}}>RFQ Generate Successfully!</Text>
                            <Link className="link" style={{fontSize: 20}} to={`/rfq/${rfq._id}`}>Click here to view RFQ</Link>
                        </>}
                        {missingProducts.length > 0 ? <Text type='danger' style={{fontSize: 15}}>{missingProducts.join(',')} not found</Text> : null}
                    </Space>
                </div>
            </Drawer>
        </Layout>
    )
}
export default AdminRFQ